<template>
  <div id="ventana" :class="widthComponent">
    <div class="sale-card d-flex" v-bind:class="{ notSellling: !isSelling, isSelling: isSelling }">
        <div class="product" :style="{ 'background-image': 'url(' + itemdata.image + ')' }">
          <div class="actions p-4 text-center">
            <div class="pricing">
                <div class="price">
                {{itemdata.price | currency}}
                </div>
                <div class="period">
                {{itemdata.period}}
                </div>
            </div>
            <div class="kind">
                <h2 class="m-0">
                {{itemdata.title}}
                </h2>
                <div class="text-uppercase mb-2">
                  <span>
                    {{itemdata.subtitle}}
                    <!-- {{index}} - {{isSellingIndex}} -->
                  </span>
                </div>
            </div>
            <button class="btn btn-danger" @click="initSale" v-if="!isSelling">
                Comprar ahora
            </button>
            </div>
        </div>
        <div class="steps flex-grow-1" v-if="isSelling">
          <form-wizard
            shape="circle"
            color="#7ED321"
            stepSize="xs"
            title=""
            subtitle=""
            back-button-text="Atras"
            next-button-text="Continuar"
            finish-button-text="Finalizar"
            @on-complete="onComplete"
            @on-change="onChange"
            ref="stepsWizard"
            >
            <tab-content title="" :before-change="()=>validateStep('step1')">
              <form-step-one ref="step1" @on-validate="mergePartialModels" :data="itemdata"/>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('step2')">
              <form-step-two ref="step2" @on-validate="mergePartialModels"/>
            </tab-content>
            <tab-content title="" :before-change="()=>validateStep('step3')">
              <form-step-three ref="step3" @on-validate="mergePartialModels"/>
            </tab-content>
            <tab-content title="" :before-change="()=>validateLastStep('step4')">
              <form-step-four ref="step4" @on-validate="mergePartialModels" :finalModel="finalModel" :itemdata="itemdata"/>
            </tab-content>
            <tab-content title="" >
              <form-step-final
                ref="step5"
                :finalModel="finalModel"
                :itemdata="itemdata"
                :saleObject="saleObject"
                :hasError="hasError"
              />
              <!-- <pre>{{finalModel}}</pre> -->
            </tab-content>
            <template slot="footer" slot-scope="props">
              <div class="text-center mb-2">
                <button class="btn btn-danger btn-danger-alt col-md-4"
                  v-if="!props.isLastStep"
                  @click="props.nextTab()"
                >
                  Siguiente
                </button>
                <button class="btn btn-danger btn-danger-alt finish-button col-md-4"
                  v-else
                  @click="onComplete"
                >
                  {{props.isLastStep ? 'Finalizar' : 'Finalizar'}}
                </button>
              </div>
              <div class="text-center">
                <button class="btn btn-default col-md-4"
                  v-if="props.activeTabIndex > 0 && !props.isLastStep"
                  @click="props.prevTab()"
                >
                  Anterior
                </button>
                <button class="btn btn-default col-md-4"
                  v-if="props.activeTabIndex == 0 && !props.isLastStep"
                  @click="clearSale"
                >
                  Cambiar selección
                </button>
              </div>
            </template>
          </form-wizard>
          <sweet-modal overlay-theme="dark" :blocking="true" :hide-close-button="true"  ref="stripeModal">
            <h5>
              Pago con tarjeta de débito o crédito
            </h5>
            <small>Por favor ingresa los datos de tu tarjea para terminar de personalizar tu Membresía Hispano Club</small>
            <card class="stripe-card"
              :class="{ complete }"
              :stripe="apiStripe"
              @change="stripeEvents"
              v-if="openStripe"
            />
            <fade-transition>
              <div v-if="stripeHasError">
                <p class="text-danger">
                  {{stripeHasError}}
                </p>
              </div>
            </fade-transition>
            <fade-transition>
            <div class="container-fluid" v-if="hasError">
              <div class="row">
                <div class="col-sm-12 text-danger">
                  <p>
                    Hubo un problema al procesar tu compra, por favor revisa los detalles a continuación e intentalo de nuevo
                  </p>
                  <h5 class="mb-0">
                    {{hasError.Error}}
                  </h5>
                </div>
              </div>
            </div>
            </fade-transition>
            <div class="le-buttons text-center">
              <div class="mt-3">
                <button class="btn btn-danger btn-danger-alt col-8" @click.prevent="pay"  :disabled='!complete' >
                  Pagar {{finalModel.price | currency}}
                </button>
              </div>
              <div  class="mt-3">
                <button class="btn btn-default" @click="cancelSale">
                  Cancelar
                </button>
              </div>
            </div>

            <fade-transition>
              <loader v-if="loading" />
            </fade-transition>
          </sweet-modal>
          <pre>
          </pre>
        </div>
      </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import Vue from 'vue'
import Loader from '@/components/Loader'
// eslint-disable-next-line
import { required, minLength, maxLength, email} from 'vuelidate/lib/validators'
import { SweetModal } from 'sweet-modal-vue'
import FormStepOne from '@/components/FormStepOne'
import FormStepTwo from '@/components/FormStepTwo'
import FormStepThree from '@/components/FormStepThree'
import FormStepFour from '@/components/FormStepFour'
import FormStepFinal from '@/components/FormStepFinal'
import { Card, createToken } from 'vue-stripe-elements-plus'
export default {
  name: 'Product',
  props: [
    'itemdata',
    'index'
  ],
  components: {
    Loader,
    SweetModal,
    FormStepOne,
    FormStepTwo,
    FormStepThree,
    FormStepFour,
    FormStepFinal,
    Card
  },
  data () {
    return {
      loading: false,
      complete: false,
      payment_token: '',
      step: 1,
      // steps: [],
      msg: 'Welcome to Your Vue.js App',
      letsInitSale: false,
      widthComponent: 'col-md-4',
      finalModel: {},
      saleObject: null,
      hasError: null,
      stripeHasError: null,
      openStripe: false
    }
  },
  validations: {
  },
  computed: {
    bgImage () {
      return require('@/assets/' + this.itemdata.image)
    },
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    apiStripe () {
      return this.$store.state.stapi
    },
    webSite () {
      return this.$store.state.wpsite.rootREST
    },
    webURL () {
      return this.$store.state.wpsite.home
    }
  },
  watch: {
    isSelling (value) {
      if (value === true) {
        this.widthComponent = 'col-md-12'
      } else {
        this.widthComponent = 'col-md-4'
      }
    }
  },
  mounted () {
    if (this.isSelling === true) {
      this.widthComponent = 'col-md-12'
    } else {
      this.widthComponent = 'col-md-4'
    }
  },
  methods: {
    initSale () {
      let self = this
      self.letsInitSale = !self.letsInitSale
      self.$store.dispatch('initSale', { payload: { process: self.letsInitSale, index: self.index }, action: 'set' })
    },
    validateStep (name) {
      var refToValidate = this.$refs[name]
      console.log('Objeto .>', this.finalModel)
      return refToValidate.validate()
    },
    validateLastStep (name) {
      var refToValidate = this.$refs[name]
      let isValidStep = refToValidate.validate()
      // console.log('paso valido', isValidStep)
      return isValidStep
    },
    mergePartialModels (model, isValid) {
      if (isValid) {
        console.log('recibiento datos', model)
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model)
      }
    },
    onComplete () {
      console.log('completado')
      this.clearSale()
      this.openURL(this.webURL + '/mi-cuenta/?wcm_redirect_to=post&wcm_redirect_id=238')
    },
    onChange (prev, next) {
      // console.log(prev)
      if (prev === 3 && next === 4) {
        this.openStripe = true
        this.$refs.stripeModal.open()
        console.log('entrando última vista')
      }
    },
    stripeEvents ($event) {
      this.complete = $event.complete
      if ($event.error) {
        console.log('cambio', $event)
        this.stripeHasError = $event.error.message
      } else {
        this.stripeHasError = null
      }
    },
    pay () {
      let self = this
      self.loading = true
      self.payment_token = ''
      createToken().then(function (response) {
        // self.$q.loading.hide()
        console.log('respuesta stripe', response.token)
        self.payment_token = response.token.id
        setTimeout(() => {
        }, 5000)
        // Añadir methodo de venta final
        self.sellMembership()
      }).catch(function (error) {
        if (error) {
          self.loading = false
          console.log('respuesta error stripe', error)
          // self.hasError = error.response.data
          // self.$q.loading.hide()
        }
      })
    },
    sellMembership (token) {
      let self = this
      // self.$q.loading.show({
      //   message: 'Procesando Membresía'
      // })
      let object = {
        payment_token: self.payment_token,
        user: {
          username: self.finalModel.email,
          password: self.finalModel.password
        },
        data: {
          // product_id: self.finalModel.product_id,
          product_sku: self.finalModel.sku,
          payment_period: self.finalModel.payment_period,
          first_name: self.finalModel.first_name,
          last_name: self.finalModel.last_name,
          email: self.finalModel.email,
          mobile_phone: self.finalModel.mobile_phone,
          address_1: self.finalModel.address_1,
          address_2: self.finalModel.address_2,
          city: self.finalModel.city,
          state: self.finalModel.state,
          postcode: self.finalModel.postcode,
          birthdate: self.finalModel.birthdate,
          seller_id: self.finalModel.seller_id,
          ssn: self.finalModel.SSN,
          itin: self.finalModel.ITIN
        },
        add_kit: self.finalModel.add_kit,
        coupon: self.finalModel.coupon

      }
      console.log('objeto a enviar', object)
      this.axios.post(self.webSite + 'hclub/sales/v1/sell-membership', object).then(function (response) {
        console.log('exito -- >', response.data)
        self.loading = false
        self.saleObject = response.data
        self.openStripe = false
        self.$refs.stripeModal.close()
        // self.$q.loading.hide()
      }).catch(function (error) {
        if (error) {
          console.log('respuesta error Servicio pago', error.response.data.Error)
          self.loading = false
          self.hasError = error.response.data
          // this.$refs.stepsWizard.prevTab()
          // self.$q.loading.hide()
        }
      })
    },
    cancelSale () {
      this.hasError = null
      this.$refs.stepsWizard.prevTab()
      this.openStripe = false
      this.$refs.stripeModal.close()
    },
    openURL (url) {
      window.open(url, '_self')
    },
    clearSale () {
      this.$store.dispatch('initSale', { action: 'clear' })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/scss/breakpoint.scss';
h1, h2 {
  font-weight: normal;
}
.notSellling {
  width: 300px;
}
.isSelling {
  width: 100%;
  .product {
    display: none;
    @include breakpoint(md) {
      display: block;
    }
  }
}
.sale-card  {
  /* border:1px solid silver;
  border-radius: 4px; */
  overflow: hidden;
  margin: 0 auto 2rem;
  /* Rectangle: */
  background: #FFFFFF;
  box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.20);
  border-radius: 4px;

}
.product   {
  width: 300px;
  min-height:360px;
  /* Rectangle 2: */
  position: relative;
  // background-image: url(https://source.unsplash.com/featured/800x600?people);
  background-size: cover;
  z-index: 2;
  &::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    background-image: linear-gradient(-180deg, rgba(5,117,230,0.32) 3%, #021B79 87%);
    z-index: 0;
  }
  .actions {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    z-index: 1;
    color:white;
    .pricing {
      .price {
        display: inline-block;
        font-size: 2rem;
      }
      .period {
        display: inline-block;
      }
    }
  }
}
.steps {
  // float: left;
  // width: calc(100% - 300px);
  flex: 1;
}
.vue-form-wizard {
  .wizard-header {
    display: none !important;
  }
  .wizard-nav {
    display: none !important;
  }
  .wizard-progress-with-circle {
    top: 0 !important;
  }
}
.StripeElement {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

.stripe-card {
  width: 100%;
  // border: 2px solid silver;
  padding: 4px;
  border-radius: 10px;
  margin: 5px 0 5px ;
}
.stripe-card.complete {
  border-color: green;
}
.fade-move{
  transition: transform .4s ease-out;
}
.btn-danger-alt {
  background-color: #FF3366 ;
  border-color: #DD194A;
  &:hover {
    background-color: #DD194A;
    border-color: #FF3366;
  }
}
.sweet-modal .sweet-content {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Product.vue